<template>
    <div class="product-edit-features" v-loading="loader">
        <el-form-item prop="type_product_id" label="Types de produit">
            <el-select  multiple @change="setFeatureList" filterable v-model="product.types_product_id" placeholder="Types de produit">
                <el-option v-for="item in typesProducts" :key="item.id" :label="item.value" :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

        <el-collapse v-model="collapsFeature" v-if="listFeatures.length">
            <el-collapse-item :class="{hasSelected: getFeatureSelectedCount(feature)}" v-for="(feature, i) in listFeatures" :key="i" :name="feature.name">
                <template #title>
                    {{ feature.name }} ({{ getFeatureSelectedCount(feature) }})
                    <span v-if="requiredFeatures.includes(feature.id)" class="required"> obligatoire</span>
                </template>
                <div class="row">
                    <template v-for="(child, index) in feature.values" >
                        <!-- Feature modèle casque -->
                        <div class="col-lg-12" :key="'casque-' + index" v-if="feature.shop_id == 93 && index == 0 || (feature.shop_id == 93 && index > 0 && feature.values[index-1].value.split(' ')[0] != child.value.split(' ')[0])">
                            <b>{{child.value.split(' ')[0]}}</b>
                        </div>
                        <!-- Feature modèle bagagerie -->
                        <div class="col-lg-12" :key="'topcase-' + index" v-if="feature.shop_id == 106 && index == 0 || (feature.shop_id == 106 && index > 0 && feature.values[index-1].value.split(' ')[0] != child.value.split(' ')[0])">
                            <b>{{child.value.split(' ')[0]}}</b>
                        </div>
                        <!-- Feature modèle platine -->
                        <div class="col-lg-12" :key="'platine-' + index" v-if="feature.shop_id == 107 && index == 0 || (feature.shop_id == 107 && index > 0 && feature.values[index-1].value.split(' ')[0] != child.value.split(' ')[0])">
                            <b>{{child.value.split(' ')[0]}}</b>
                        </div>
                        <div class="col-lg-3" :key="index">
                            <el-checkbox
                                size="mini"
                                v-model="product.featuresIds"
                                :disabled="(feature.name === 'Garantie' && getFeatureSelectedCount(feature) > 0) && !product.featuresIds.includes(child.id)"
                                :label="child.id"
                                border
                            >
                                {{child.value}}
                            </el-checkbox>
                        </div>
                    </template>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
export default {
data() {
        return {
            loader: false,
            typesOptions: [],
            typesProducts: [],
            collapsFeature: [],
            listFeatures: [],
            requiredFeatures: []
        }
    },
    props: {
        product: {
            required: true
        }
    },
    computed: {
        productId() {
            return this.product.id;
        },
        // listFeatures() {
        //     let features = [];
        //
        //     if( !this.product.types_product_id ) {
        //         return features;
        //     }
        //
        //     this.product.types_product_id.forEach((v)=>{
        //         let type = this.typesOptions.find((t) => t.id == v );
        //         if( type ) {
        //             type.features_list_value.forEach((fl)=>{
        //                 if(!features.find(f => f.id == fl.id )) {
        //                     features.push( fl );
        //                 }
        //             })
        //         }
        //     })
        //
        //     if (features.length) {
        //         let indexFirst = features.findIndex(f => f.name == 'New');
        //         let indexSecond = features.findIndex(f => f.name == 'Univers');
        //
        //         if(indexFirst > -1 && indexSecond > -1) {
        //             let toInsert = features[indexSecond];
        //
        //             features.splice(indexFirst + 1 , 0, toInsert);
        //             features.splice(indexSecond + 1, 1);
        //         }
        //
        //     }
        //
        //     return features;
        // }
    },
    created() {
        this.loader = true;
        axios.get('/filters/features/typesProduct').then(r => {
            this.typesProducts = r.data.data;
            this.loader = false;
        })
            .then(() => {
                if (!this.product.types_product_id.length) {
                    return;
                }

                this.loadRequiredFeatures();
                this.loadFeaturesValues([this.product.types_product_id])
            })
    },
    methods: {
        getFeatureSelectedCount(feature) {
            return this.product.featuresIds.filter(
                v => feature.values.filter(r => r.id == v).length
            ).length;
        },
        setFeatureList() {
            this.product.featuresIds = [];
            if( this.product.types_product_id.length ) {
                this.product.featuresIds = this.product.types_product_id
            }

            this.loadFeaturesValues(this.product.featuresIds);
        },
        loadFeaturesValues(featuresIds) {
            if (!featuresIds.length) {
                this.listFeatures = [];
                return;
            }

            this.loader = true;
            axios.get('/features/typesProduct/' + featuresIds + '/values', {
                params: {
                    featuresIds: featuresIds
                }
            }).then(r => {
                this.loader = false;
                this.listFeatures = r.data.data;
            });
        },
        loadRequiredFeatures() {
            this.loader = true;
            let product_type_id = this.product.types_product_id;

            if (!product_type_id) {
                return;
            }

            axios.get('/features/typesProduct/' + product_type_id + '/required-features')
                .then(r => {
                    this.loader = false;
                    this.requiredFeatures = r.data;
                });
        }
    },
    watch: {
        'product.types_product_id': function (val) {
            if (!val.length) {
                this.listFeatures = [];
                return;
            }

            this.loadFeaturesValues([this.product.types_product_id])
        }
    }
}
</script>

<style lang="scss">
    .product-edit-features {
        .el-select {
            width: 100%;
        }
    }

    .required {
        color: red;
        font-size: 12px;
    }
</style>
